import { type FC } from 'react';
import type {
  DataTableColumn,
  DataTableColumnGroupingData,
  DataTableDimensions,
} from '@/components/UI/DataTableV2/DataTable.model';
import { DataTableColumnHeader } from './DataTableColumnHeader';
import { useDataTable } from '../DataTableProvider';
import cn from 'classnames';
import styles from '../DataTableV2.module.scss';

interface StickyPinnedColumnHeadersProps {
  pinnedDataColumns: Array<DataTableColumn>;
  rowHeaderWidth: number;
  groupHeaderHeight: number;
  dimensions: DataTableDimensions;
  columnGroupingData?: DataTableColumnGroupingData | null;
}

export const StickyPinnedColumnHeaders: FC<StickyPinnedColumnHeadersProps> = ({
  pinnedDataColumns,
  rowHeaderWidth,
  groupHeaderHeight,
  dimensions,
  columnGroupingData,
}) => {
  const { dataTableService } = useDataTable();

  return (
    <>
      {pinnedDataColumns.map((column, index) => {
        const columnIndex = dataTableService.toIndexColumn(column.id);
        if (columnIndex === undefined) {
          return null;
        }

        const isGrouped = columnGroupingData?.columnGroupMap.has(columnIndex) ?? false;
        const hasGroupBorder = dataTableService.rightBorderType(columnIndex) === 'group-separator';
        const xPosition = rowHeaderWidth + index * dimensions.cellWidth;

        return (
          <div key={column.id}>
            {/* Render placeholder for non-grouped columns in group header row */}
            {!isGrouped && groupHeaderHeight > 0 && (
              <div
                className={cn(styles.columnHeaderContainer, 'bg-white', { [styles.groupBorder]: hasGroupBorder })}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: xPosition,
                  width: dimensions.cellWidth,
                  height: groupHeaderHeight,
                }}
              />
            )}
            <DataTableColumnHeader
              columnIndex={columnIndex}
              positionOffset={{
                x: xPosition,
                y: groupHeaderHeight,
              }}
            />
          </div>
        );
      })}
    </>
  );
};
